import React from 'react'

export function useModalVisibility() {
  const [isModalVisible, setIsModalVisible] = React.useState(false)
  const toggleModal = () => {
    setIsModalVisible(!isModalVisible)
  }
  return [isModalVisible, toggleModal, setIsModalVisible]
}
